export default __webpack_public_path__ + "static/media/email_icon.433a749d.svg";